'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toast = require('./toast');

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _toast2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/toast/index.js
// module id = 278
// module chunks = 0